var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-card", { staticClass: "box-card" }, [
    _c(
      "div",
      {
        staticClass: "clearfix vertical-centered",
        attrs: { slot: "header" },
        slot: "header",
      },
      [
        _c("span", { staticClass: "header-item" }, [_vm._v("Schedules")]),
        _vm._v(" "),
        _c("span", { staticClass: "ring-card__header-buttons custom-margin" }, [
          _c(
            "small",
            [
              _c(
                "TextLink",
                {
                  on: {
                    click: function ($event) {
                      return _vm.showHelp()
                    },
                  },
                },
                [_vm._v("Need help adding a schedule?")]
              ),
            ],
            1
          ),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "card-content" },
      [
        _c("schedules-tabs", {
          attrs: { slot: "default", "device-name": _vm.deviceName },
          slot: "default",
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }